
const utils = require ('./detail_utilities.js');

require ('./table_functions.js');

//form elements
const CheckBox = require('./elements/checkBox.js');
const Dropdown = require('./elements/dropdown.js');
const Label = require('./elements/label.js');
const Map = require('./elements/map.js');
const RadioButton = require('./elements/radioButton.js');
const Table = require('./elements/table.js');
const Tabs = require('./elements/tabs.js');
const TextBox = require('./elements/textBox.js');

define(function (require) {
	
	var buildContents = function (ele, readOnlyForm, detailOptions) {
		if (!ele.id) {
			ele.id = utils.generateId();
		}
		if (ele.isHtml!==true){
			//if this is a wizard, and not a panel or tab element, check if the text contains HTML
			if(detailOptions.fromWizard && !_.isEmpty(ele.type) && ele.type.toLowerCase()=='panel' != ele.type.toLowerCase()!='tab'){
				ele.isHtml = isHtmlString(ele.text);
			} else {
				ele.isHtml = false;
			}
			ele.text = utils.cleanFormatTags(ele.text);
		}
		if (ele.type == 'Tab') {
			return Tabs.getTab(ele, readOnlyForm, detailOptions, buildWrapperDivAndContents);
		}
		else if (ele.type == 'CheckBox') {
			return CheckBox.getCheckBox(ele, readOnlyForm, detailOptions);
		}
		else if (ele.type == 'RadioButton') {
			return RadioButton.getRadio(ele, readOnlyForm, detailOptions);
		}
		else if (ele.type == 'DropDownBox') {
			return Dropdown.getDropdown(ele, readOnlyForm, detailOptions);
		}
		else if (ele.type == 'Label') {
			return Label.getLabel(ele, true, detailOptions);
		}
		else if (ele.type == 'Html') {
			return Label.getLabel(ele, false, detailOptions);
		}
		else if (ele.type == 'TextBox') {
			return TextBox.getTextBox(ele, readOnlyForm, detailOptions);
		}
		else if (ele.type == 'Table') {
			return Table.getTable(ele, readOnlyForm, detailOptions);
		}
		else if (ele.type == 'Map') {
			return Map.getMap(ele, readOnlyForm, detailOptions);
		}
		else if (ele.type == 'Panel') {
			// if the panel has a text, display the title
			var el;
			if(ele.text==null || ele.text==undefined || ele.text=="" || (ele.text && ele.text.trim()=="")){
				el = $('<div/>');
			} else {
				el = $('<fieldset/>');
				el.attr('class', '');
				var label = $('<legend/>', {});
				label.text(ele.text);
				if (!ele.hasHeader) {
					label.hide();
				}
				el.append(label);
			}
			el.append(buildWrapperDivAndContents(ele.elements, readOnlyForm, detailOptions));
			return el;
		}
	};
	var buildWrapperDivAndContents = function (elements, readOnlyForm, detailOptions) {
		var el = $('<div/>', {
			class: 'blank'
		});
		if(readOnlyForm){
			el.addClass('readOnly');
		}
		_.forEach(elements, function (ele) {
			var inner = buildContents(ele, readOnlyForm, detailOptions);
			el.append(inner);
		});
		return el;
	};
	//we add the htmlString to a temporary html object. If it contains HTML, it will be parsed as such.
	//the text returned by .text() will omit the HTML elements, meaning if the test string != htmlString, htmlString contained HTML markup
	var isHtmlString = function (htmlString){
		if(_.isEmpty(htmlString)){
			return false;
		}
		var test = $('<div></div>').html(htmlString).text();
		return test != htmlString;
	};
	return {
		getContent: function (doc, initialEnabled, detailOptions, fromWizard) {
			let detailPageId = utils.generateId();;
			let defaultDetailOptions = {};

			var autoHtml = fromWizard === true ? true : false;
			var detailOptionsExtended = $.extend({}, defaultDetailOptions, detailOptions, {fromWizard:autoHtml, detailPageId:detailPageId});
			var readOnlyForm = initialEnabled == undefined ? false : !initialEnabled;
			if (doc && doc.elements && _.isArray(doc.elements)) {
				var wrapper = buildWrapperDivAndContents(doc.elements, readOnlyForm, detailOptionsExtended);
				wrapper.attr('data-detailpageid',detailPageId);
				wrapper.addClass('detail-page-wrapper');
				return wrapper[0].outerHTML;
			}
			return null;
		}
	};
});
